import $ from "jquery";

if (document.querySelector(".slidergridproducts")) {

    const slidergridproduct = document.querySelectorAll(".slidergridproducts");

    slidergridproduct.forEach(cardSlider => {
        $(cardSlider).slick({
            dots: false,
            autoplay: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false,
            responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            }, {
                breakpoint: 769,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },]

        });
    });
}